import axios from "@axios";
import { useUtils as useI18nUtils } from "@core/libs/i18n"

// i18n constant
const { t } = useI18nUtils();


export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((item) => ({
        name: item.name,
        description: item.description,
      }));
    },
    getProviderItems(state) {
      return state.items.filter(item =>
        item.description === "equal_to" || item.description === "no_equal_to"
      );
    }
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {

    //getAll Retrieves all rules for the grid table view.
    async getAll({ commit }, params) {

      const data = [
        {
          name: t('match_rules_action.contains'),
          description: "contains"
        },
        {
          name: t('match_rules_action.equal_to'),
          description: "equal_to"
        },
        {
          name: t('match_rules_action.no_equal_to'),
          description: "no_equal_to"
        },
        {
          name: t('match_rules_action.greater_than'),
          description: "greater_than"
        }
      ]

      commit("setData", data);
      return data;
    },
    //clear Clears the stored list of actions in the state.
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
